module.exports = __webpack_public_path__ + "img/fine-music.5112bd39.png";